<template>
<div class="chapter">
<div class="inner_page">
<div id="Table-of-Contents.html" xml:lang="en-US">
<div class="Basic-Text-Frame-8">
<p class="TOCtitle"><span class="bold">Table of Contents</span></p>
<p class="TOCitem"><a href="#/ThePrinceSheNeverKnew#Anchor-1">The Prince She Never Knew</a></p>
<p class="TOCitem"><span href="#/KholodovsLastMistressofbook2#Anchor-1" title="Link target outside of Sample">Kholodov’s Last Mistress</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TableofContents.vue?77b8a58b